import React from "react";
import styles from "./VoiceAIUseCases.module.css";
import {
    Headphones,
    Target,
    DollarSign,
    Calendar,
    Clock,
    TrendingUp,
    ShieldCheck,
    Percent,
    CheckCircle2
} from "lucide-react";

const useCases = [
    {
        icon: <Headphones />,
        title: "Customer Support",
        desc: "24/7 voice support that resolves inquiries, troubleshoots issues, and escalates intelligently.",
        stats: [
            { icon: <CheckCircle2 />, label: "70% auto resolution" },
            { icon: <Clock />, label: "< 30s answer time" },
            { icon: <TrendingUp />, label: "60% cost savings" },
        ],
    },
    {
        icon: <Target />,
        title: "Sales & Lead Qualification",
        desc: "Instant lead response, BANT qualification, and demo scheduling via AI voice.",
        stats: [
            { icon: <Clock />, label: "5s response time" },
            { icon: <TrendingUp />, label: "3x conversion rate" },
            { icon: <CheckCircle2 />, label: "24/7 availability" },
        ],
    },
    {
        icon: <DollarSign />,
        title: "Collections & Reminders",
        desc: "Compliant debt collection, payment reminders, and EMI follow-ups with empathetic tone.",
        stats: [
            { icon: <TrendingUp />, label: "40% higher recovery" },
            { icon: <ShieldCheck />, label: "100% TCPA compliant" },
            { icon: <Percent />, label: "60% cost reduction" },
        ],
    },
    {
        icon: <Calendar />,
        title: "Appointment Scheduling",
        desc: "Book, confirm, and remind appointments with calendar integration and smart scheduling.",
        stats: [
            { icon: <CheckCircle2 />, label: "85% booking rate" },
            { icon: <TrendingUp />, label: "40% fewer no shows" },
            { icon: <CheckCircle2 />, label: "Zero double bookings" },
        ],
    },
];

const features = [
    "Vox Text-to-Speech engine",
    "Real-time sentiment analysis",
    "Multi-language code-mixing support",
    "Custom voice cloning (coming soon)",
    "CRM & telephony integration",
    "Call recording & transcription",
    "Live call monitoring dashboard",
    "API & Webhook integrations",
    "A/B testing for scripts",
    "Detailed analytics & reporting",
];

const VoiceAIUseCases = () => {
    return (
        <section className={styles.wrapper}>
            {/* Use cases */}
            <h2 className={styles.title}>Voice AI Use Cases</h2>
            <p className={styles.subtitle}>
                From inbound support to outbound campaigns voice agents that deliver results.
            </p>

            <div className={styles.cardsGrid}>
                {useCases.map((item, i) => (
                    <div className={styles.card} key={i}>
                        <div className={styles.cardHeader}>
                            <div className={styles.iconBox}>{item.icon}</div>
                            <h3>{item.title}</h3>
                        </div>

                        <p className={styles.desc}>{item.desc}</p>

                        <div className={styles.stats}>
                            {item.stats.map((stat, idx) => (
                                <div key={idx} className={styles.statItem}>
                                    {stat.icon}
                                    <span>{stat.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Enterprise features */}
            <h2 className={styles.title}>Enterprise-Grade Features</h2>
            <p className={styles.subtitle}>
                Everything you need to deploy voice AI agents at scale.
            </p>

            <div className={styles.featureBox}>
                {features.map((feature, i) => (
                    <div key={i} className={styles.featureItem}>
                        <CheckCircle2 />
                        <span>{feature}</span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default VoiceAIUseCases;